const IconDocument = ({ className }) => {
    return (
        <svg viewBox='0 0 46 47' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path
                d='M26.8327 4.70001V16.2H38.3327M30.666 25.7833H15.3327M30.666 33.45H15.3327M27.791 4.70001H11.4993C10.4827 4.70001 9.50766 5.10388 8.78877 5.82277C8.06988 6.54166 7.66602 7.51668 7.66602 8.53335V39.2C7.66602 40.2167 8.06988 41.1917 8.78877 41.9106C9.50766 42.6295 10.4827 43.0333 11.4993 43.0333H34.4993C35.516 43.0333 36.491 42.6295 37.2099 41.9106C37.9288 41.1917 38.3327 40.2167 38.3327 39.2V15.2417L27.791 4.70001Z'
                strokeWidth='2.48649'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconDocument;
